/// <reference path="../../../../../typings/index.d.ts" />

module Meevo.Components.Controls {
    "use strict";

    export class SmartCenterDesignerProperties implements angular.IComponentOptions {

        templateUrl = "app/components/controls/smartCenterDesigner/smartCenterDesignerProperties.component.html";
        bindings: any = {
            tile: '=?',
            smartcenterBusinessTypeId: '=?',
            smartcenterIsAvailableCo: '=?',
            editCompleted: '&?'
        }
        controller = class SmartCenterDesignerProperties {

            static $inject = [
                "meevo.components.modal.ModalService",
                "meevo.components.common.DataService",
                "meevo.components.common.IdentityService",
                "$scope",
                "$translate"
            ];

            private tileNames = Meevo.Plugins.SmartCenter.SmartTileNames;
            private locationId = this.identityService.locationId;

            public parameterTypes: Meevo.Model.SmartTileParameterTypes = Meevo.Model.SmartTileParameterTypes;
            public editCompleted: Function;
            public isDisplayNameEditable: boolean = true;
            public isDisplayNameHidden: boolean = false;
            public isAspectRatioValid: boolean = true;
            public oldSize = {
                rowSpan: 0,//this.tile.rowSpan,
                columnSpan: 0 //this.tile.columnSpan
            }
            public showDetail: any;
            private _tile: Meevo.Model.SmartCenterSmartTile;
            get tile(): Meevo.Model.SmartCenterSmartTile {
                return this._tile;
            }
            set tile(value: Meevo.Model.SmartCenterSmartTile) {
                this._tile = value;
                SmartCenterDesignerPropertiesHelper.buildDefaultDisplayName(this.translate, this.tile);
                this.initializeProperties();
                if (this._tile) {
                    if (this._tile.columnSpan && this._tile.rowSpan) {
                        this.oldSize.columnSpan = this._tile.columnSpan;
                        this.oldSize.rowSpan = this._tile.rowSpan;
                    }
                    if (this.tile.parsedParameters["locations"].parameterValue) {
                        this.tile.isForLocationGroup = false;
                    }
                    if (this.tile.parsedParameters["locationsGroup"].parameterValue) {
                        this.tile.isForLocationGroup = true;
                    }
                    
                    this._tile.decOverride = this.translate.instant(this._tile.desc);
                    this.showDetail = _(this._tile.parsedParameters).findWhere({ parameterType: "ShowDetail" });
                }
            }

            public getAspectRatio() {
                return this.tile.columnSpan / this.tile.rowSpan;
            }

            contentType = "image/png";

            constructor(protected modalService: Meevo.Components.Modal.IModalService,
                protected dataService: Components.BaseClasses.IDataService,
                protected identityService: Meevo.Components.Common.IIdentityService,
                protected $scope: any,
                protected translate: angular.translate.ITranslateService) {
            }

            initializeProperties() {
                if (this.tile && this.tileNames) {
                    // TODO: Revisit this. ID is really not readable here but tile.smartTileName isn't
                    // populated on new's since the tile definition endpoint isn't returning it.
                    switch (this.tile.smartTileName) {
                        case this.tileNames.menuShortcut: // 28: // Shortcut
                            this.isDisplayNameHidden = true;
                            break;
                        case this.tileNames.appointmentServices: // 3: // AppointmentServices
                        case this.tileNames.estimatedSales: // 4: // EstimatedSales
                        case this.tileNames.hoursNotSold: // 7: // HoursNotSold
                        case this.tileNames.newClientsWithAppointments: // 8: // NewClientsWithAppointments
                        case this.tileNames.appointments: // 11: // Appointments
                        case this.tileNames.rebookedAppointments: // 12: // RebookedAppointments
                        case this.tileNames.noShowAppointments: // 13: // NoShowAppointments
                        case this.tileNames.percentageBooked: // 21: // PercentageBooked
                        case this.tileNames.netSales: // 22: // NetSales
                        case this.tileNames.serviceAddonsToday: // 33: // ServiceAddonsToday
                        case this.tileNames.appointmentsToReschedule: // 36: // AppointmentsToReschedule
                        case this.tileNames.appointmentCount: // 37: // Appointment Count
                        case this.tileNames.topServicesPerformed: // 38: // Top Services Performed
                        case this.tileNames.topServicesBooked: // 55: // Top Services Booked
                        case this.tileNames.todaysWaitList: // 39: // Today's Wait List
                        case this.tileNames.ratingTile: // 42: // Five Star Rating
                        case this.tileNames.сhurnMonthlyRecurringRevenue: // 45: // Churn MRR
                        case this.tileNames.expansionMonthlyRecurringRevenue: // 46: // Expansion MRR
                        case this.tileNames.growthMonthlyRecurringRevenue: // 47: // Growth MRR
                        case this.tileNames.rebookedServices: // 48: // Rebooked Services
                        case this.tileNames.clientBirthdayOrAnniversary: //50 //Client birthday/anniversary
                        case this.tileNames.countOfCurrentMemberships: // 51: // Count Of Memberships
                        case this.tileNames.employeeBirthdayAnniversary:
                        case this.tileNames.serviceCategorySales: // 53: // ServiceCategorySales
                        case this.tileNames.productCategorySales: // 56: // ProductCategorySales
                            this.isDisplayNameEditable = false;
                            break;
                        default:
                            this.isDisplayNameEditable = true;
                            this.isDisplayNameHidden = false;
                            break;
                    }
                }
            }

            public onResize() {
                let that = this;

                let oldAspectRatio = this.oldSize.columnSpan / this.oldSize.rowSpan;
                let newAspectRatio = this.getAspectRatio();
                let finalColumn = this._tile.columnSpan + this._tile.columnPosition;
                let finalRow = this._tile.rowSpan + this._tile.rowPosition;
                let maxColumns = 6;
                let maxRows = 3;

                if (finalColumn > maxColumns) {
                    let difference = finalColumn - maxColumns
                    this._tile.columnSpan = this._tile.columnSpan - difference;
                }

                if (finalRow > maxRows) {
                    let difference = finalRow - maxRows
                    this._tile.rowSpan = this._tile.rowSpan - difference;
                }
                if (this._tile.smartTileName == "Image") {
                    if (newAspectRatio != 1 && newAspectRatio != 2 && newAspectRatio != 4 && newAspectRatio != .5 && newAspectRatio != 1 / 3 && newAspectRatio != 3) {
                        this.isAspectRatioValid = false;
                        //this.smartCenterRowSpan.$setValidity()
                        //this.$scope.smartCenterRowSpan.$setValidity("aspectRatio", false);
                        //this.$scope.smartCenterColumnSpan.$setValidity("aspectRatio", false);
                    }
                    else {
                        this.isAspectRatioValid = true;
                        //this.smartCenterRowSpan.$setValidity()
                        //this.$scope.smartCenterRowSpan.$setValidity("aspectRatio", true);
                        //this.$scope.smartCenterColumnSpan.$setValidity("aspectRatio", true);
                    }


                    if (oldAspectRatio != newAspectRatio) {
                        if (that.tile.parsedParameters[Meevo.Model.SmartTileParameterNames.image].parameterValue.fileGuid) {
                            this.modalService.confirmHandler("MESSAGE_IMAGE_RESIZE_WARNING")
                                .then(function (response) {

                                    if (!response) {
                                        that.tile.rowSpan = that.oldSize.rowSpan;
                                        that.tile.columnSpan = that.oldSize.columnSpan;
                                    }
                                    else {

                                        let deleteJson = {
                                            FileGuid: that.tile.parsedParameters[Meevo.Model.SmartTileParameterNames.image].parameterValue.fileGuid,
                                            LocationId: that.locationId,
                                            ResourceType: that.tile.parsedParameters[Meevo.Model.SmartTileParameterNames.image].parameterValue.meevoFile.storageTypeEnum
                                        }
                                        //that.dataService.deleteFile("Storage/api", deleteJson);
                                        that.tile.parsedParameters[Meevo.Model.SmartTileParameterNames.image].parameterValue.fileGuid = "";
                                        that.tile.parsedParameters[Meevo.Model.SmartTileParameterNames.image].parameterValue.meevoFile = undefined;

                                    }
                                    that.oldSize.rowSpan = that.tile.rowSpan;
                                    that.oldSize.columnSpan = that.tile.columnSpan;
                                });

                        }
                    }
                }

            }

            public getImageUrl(istoreObj, defaultUri) {
                return Model.StorageFileHelper.imageUri(istoreObj, defaultUri)
            }

            public onParameterChanged(selection: Model.EnumDto): void {
                SmartCenterDesignerPropertiesHelper.buildDefaultDisplayName(this.translate, this.tile);
            }

            public getIncludedDateRanges(): number[] {
                return SmartCenterDesignerPropertiesHelper.getIncludedDateRanges(this.tile);
            }

            public getExcludedDateRanges(): number[] {
                return SmartCenterDesignerPropertiesHelper.getExcludedDateRanges(this.tile);
            }

            private completeEdit(): void {
                this.editCompleted();
            }

            _statuses: any;
            public statuses(tile: Model.SmartCenterSmartTile): any {
                if (!this._statuses) {
                    this._statuses = SmartCenterDesignerPropertiesHelper.getStatuses(tile.id);
                }
                return this._statuses;
            }

            _sortFields: any;
            public sortFields(tile: Model.SmartCenterSmartTile): any {
                if (!this._sortFields) {
                    if (tile.id == Meevo.Model.SmartTileIds.ServiceProviderRequests) {
                        this._sortFields = [{ value: "RequestPercentage", display: "LABEL_REQUEST_PERCENTAGE" },
                            { value: "Employee", display: "LABEL_EMPLOYEE" }];
                    }
                }
                return this._sortFields;
            }

            public showTimePeriod(param) {
                let show = false;
                if (param.parameterType === Meevo.Model.SmartTileParameterTypes.timePeriod) {
                    show = true;
                    if (this.tile.id == Meevo.Model.SmartTileIds.AppointmentCount) {
                        let appointmentStateParam: any = _(this.tile.parsedParameters).findWhere({ parameterType: Meevo.Model.SmartTileParameterTypes.appointmentState });
                        if (appointmentStateParam && (appointmentStateParam.parameterValue == Meevo.Model.AppointStateEnum[Meevo.Model.AppointStateEnum.NoShow] ||
                            appointmentStateParam.parameterValue == Meevo.Model.AppointStateEnum[Meevo.Model.AppointStateEnum.RunningLate])) {
                            param.parameterValue = Meevo.Model.TimePeriodEnum[Meevo.Model.TimePeriodEnum.Today];
                            show = false;
                        }
                    }
                }
                return show;
            }
            fileTypesEnum = Meevo.Model.FileTypes;
        }
    }


    export class SmartCenterDesignerPropertiesHelper {
        public static getStatuses(tileId: number) {
            if (tileId == Meevo.Model.SmartTileIds.AppointmentCount) {
                return [{ value: "CheckedIn", display: "LABEL_CHECKED_IN", isVisible:false},
                    { value: "Booked", display: "LABEL_BOOKED", isVisible: true },
                    { value: "RunningLate", display: "LABEL_RUNNING_LATE", isVisible: true },
                    { value: "NoShow", display: "LABEL_NO_SHOW", isVisible: true },
                    { value: "Confirmed", display: "LABEL_CONFIRMED", isVisible: true },
                    { value: "AwaitingResponse", display: "LABEL_WAITING_ON_REPLY", isVisible: true },
                    { value: "UnableToContact", display: "LABEL_UNABLE_TO_CONTACT", isVisible: true },
                    { value: "Unconfirmed", display: "LABEL_UNCONFIRMED", isVisible: true },
                    { value: "Cancelled", display: "LABEL_CANCELED", isVisible: true },
                    { value: "RespondedReschedule", display: "LABEL_REQUESTED_RESCHEDULE", isVisible: true }]
            }
            else {
                return [{ value: "Booked", display: "LABEL_BOOKED", isVisible: true },
                    { value: "CheckedIn", display: "LABEL_CHECKED_IN", isVisible: true },
                    { value: "RunningLate", display: "LABEL_RUNNING_LATE", isVisible: true },
                    { value: "NoShow", display: "LABEL_NO_SHOW", isVisible: true },
                    { value: "Conflict", display: "LABEL_CONFLICT", isVisible: true }
                ]
            }
        }
        constructor(private translate?: angular.translate.ITranslateService) { }

        private static updateIncludeEmployee(translate: angular.translate.ITranslateService, tile: Model.SmartCenterSmartTile): string {
            var myParameter = _.find(tile.parsedParameters, p => p.parameterType === 'IncludedEmployees');
            if (Model.Guard.isSomething(myParameter) && myParameter.parameterValue === 'LoggedInEmployee') {
                tile.includedEmployee = Meevo.Model.IncludedEmployeeEnum.LoggedInEmployee;
                return translate.instant('LABEL_MY') + ' ';
            } else {
                tile.includedEmployee = Meevo.Model.IncludedEmployeeEnum.AllEmployees;
                return '';
            }
        }

        private static updateSpecificEmployee(translate: angular.translate.ITranslateService, tile: Model.SmartCenterSmartTile): string {
            let specificEmployeeLabel = '';
            const myParameter = _.find(tile.parsedParameters, p => p.parameterType === Model.SmartTileParameterTypes.includedEmployees);
            if (Model.Guard.isSomething(myParameter) && myParameter.parameterValue === 'SpecificEmployee') {
                const employeeCode = tile.parsedParameters[Meevo.Model.SmartTileParameterNames.employeeCode]
                    ? tile.parsedParameters[Meevo.Model.SmartTileParameterNames.employeeCode].parameterValue
                    : '';
                if (employeeCode) {
                    specificEmployeeLabel = ' ' + translate.instant('LABEL_FOR_EMPLOYEE_CODE', { employeeCode: employeeCode });
                }
            }
            return specificEmployeeLabel;
        }

        private static updateTimePeriod(translate: angular.translate.ITranslateService, tile: Model.SmartCenterSmartTile): string {
            var tpParameter = _.find(tile.parsedParameters, p => p.parameterType === 'TimePeriod');
            if (Model.Guard.isSomething(tpParameter)) {
                return translate.instant('{{ tp }}', { tp: tpParameter.parameterDisplayName });
            } else {
                return '';
            }
        }
        private static updateDueInDisplay(translate: angular.translate.ITranslateService, tile: Model.SmartCenterSmartTile): string {
            var tpParameter = _.find(tile.parsedParameters, p => p.parameterType === 'DueIn');
            if (Model.Guard.isSomething(tpParameter) && tpParameter.parameterValue) {
                return translate.instant('{{ tp }}', { tp: tpParameter.parameterDisplayName });
            } else {
                return translate.instant('LABEL_WITH_APPOINTMENTS_ABBREV');
            }
        }

        private static updateRebookDisplay(translate: angular.translate.ITranslateService, tile: Model.SmartCenterSmartTile): string {
            var tpParameter = _.find(tile.parsedParameters, p => p.parameterType === Meevo.Model.SmartTileParameterTypes.rebookingType);
            if (Model.Guard.isSomething(tpParameter) && tpParameter.parameterValue &&
                +tpParameter.parameterValue === Model.SmartTileRebookingType.NotRebooked) {
                return translate.instant("LABEL_SMART_TILE_CLIENTS_NOT_REBOOKED");
            }
            return translate.instant("LABEL_SMART_TILE_CLIENTS_REBOOKED");
        }

        private static updateMultiSelection(translate: angular.translate.ITranslateService, tile: Model.SmartCenterSmartTile): string {
            const selections = Array.isArray(tile.parsedParameters.multiSelectTemplateKey.selections) && Array.from(tile.parsedParameters.multiSelectTemplateKey.selections, s => s.displayName);
            let labels = ''
            if (!!selections) {
                selections.forEach(s => {
                    /**
                     * Custom Label Support : `LABEL_${s.toUpperCase()}` LABEL_PRODUCT which value is {{Product}} therefore will be processed as Custom Label
                     * */
                    const label = translate.instant(`LABEL_${s.toUpperCase()}`);
                    labels += label === `LABEL_${s.toUpperCase()}`
                        ? `${translate.instant('{{selection}}', { selection: s })}, `
                        : `${label}, `
                });
                return labels.slice(0, -2);
            }
        }


        public static buildDefaultDisplayName(translate: angular.translate.ITranslateService,
            tile: Model.SmartCenterSmartTile) {
            if (tile) {
                const timePeriod = this.updateTimePeriod(translate, tile);
                const myLabel = this.updateIncludeEmployee(translate, tile);
                const specificEmployeeLabel = this.updateSpecificEmployee(translate, tile);
                const tileNames = Meevo.Plugins.SmartCenter.SmartTileNames;
                switch (tile.smartTileName) {
                    case tileNames.appointmentServices: { // 3: // AppointmentServices
                        var name = translate.instant('SMARTTILE_SERVICES_BOOKED');
                        tile.displayNameOverride = `${myLabel}${name}${specificEmployeeLabel} ${timePeriod}`;
                        break;
                    }
                    case tileNames.estimatedSales: {
                        // 4: EstimatedSales
                        let name = translate.instant('SMARTTILE_ESTIMATED_SALES', { timeperiod: timePeriod });
                        tile.displayNameOverride = `${myLabel}${name}${specificEmployeeLabel}`;
                        break;
                    }
                    case tileNames.clientsRunningLate: {
                        // 5: ClientsLateForAppointments
                        let name = translate.instant('SMARTTILE_CLIENTS_RUNNING_LATE');
                        tile.displayNameOverride = `${name}`;
                        break;
                    }
                    case tileNames.clientsWithAppointments: {
                        // 6: ClientsWithAppointments
                        let name = translate.instant('SMARTTILE_CLIENTS', { timeperiod: timePeriod });
                        tile.displayNameOverride = `${myLabel}${name}${specificEmployeeLabel}`;
                        break;
                    }
                    case tileNames.hoursNotSold: {
                        // 7: HoursNotSold
                        let name = translate.instant('SMARTTILE_HOURS_AVAILABLE_TO_SELL', { timeperiod: timePeriod });
                        tile.displayNameOverride = `${myLabel}${name}${specificEmployeeLabel}`;
                        break;
                    }
                    case tileNames.newClientsWithAppointments: {
                        // 8: NewClientsWithAppointments
                        let name = translate.instant('SMARTTILE_NEW_CLIENTS');
                        let dueInDisplayName = this.updateDueInDisplay(translate, tile);
                        tile.displayNameOverride = `${myLabel}${name}${dueInDisplayName} ${timePeriod}${specificEmployeeLabel}`;
                        break;
                    }
                    case tileNames.appointments: {
                        // 11: Appointments
                        let name = translate.instant('SMARTTILE_APPT_TICKETS', { timeperiod: timePeriod });
                        tile.displayNameOverride = `${myLabel}${name}${specificEmployeeLabel}`;
                        break;
                    }
                    case tileNames.rebookedAppointments: {
                        // 12: RebookedClients
                        let rebookOption = this.updateRebookDisplay(translate, tile);
                        tile.displayNameOverride = `${myLabel}${rebookOption} ${timePeriod}${specificEmployeeLabel}`;
                        break;
                    }
                    case tileNames.noShowAppointments: {
                        // 13: NoShowAppointments
                        let name = translate.instant('SMARTTILE_NO_SHOW_APPTS');
                        tile.displayNameOverride = `${myLabel}${name}${specificEmployeeLabel}`;
                        break;
                    }
                    case tileNames.percentageBooked: {
                        // 21: PercentageBooked
                        let name = translate.instant('SMARTTILE_PERCENTAGE_BOOKED');
                        tile.displayNameOverride = `${myLabel}${name}${specificEmployeeLabel} ${timePeriod}`;
                        break;
                    }
                    case tileNames.netSales: {
                        // 22: NetSales
                        let salesType = tile.parsedParameters[Meevo.Model.SmartTileParameterNames.salesType].parameterDisplayName;
                        let name = translate.instant('SMARTTILE_NET_SALES', { salesType: salesType, timeperiod: timePeriod });
                        tile.displayNameOverride = `${myLabel}${name}${specificEmployeeLabel}`;
                        break;
                    }
                    case tileNames.serviceAddonsToday: {
                        // 33: ServiceAddonsToday
                        let name = translate.instant('SMARTTILE_SERVICE_ADD_ONS', { timeperiod: timePeriod });
                        tile.displayNameOverride = `${myLabel}${name}${specificEmployeeLabel}`;
                        break;
                    }
                    case tileNames.appointmentsToReschedule: {
                        // 36: AppointmentsToReschedule
                        let name = translate.instant('SMARTTILE_APPTS_TO_RESCHEDULE', { timeperiod: timePeriod });
                        tile.displayNameOverride = `${myLabel}${name}${specificEmployeeLabel}`;
                        break;
                    }
                    case tileNames.appointmentCount: {
                        // 37: AppointmentCount
                        let apptState = tile.parsedParameters[Meevo.Model.SmartTileParameterNames.appointmentState].parameterValue;
                        let status = _(this.getStatuses(tile.id)).findWhere({ value: apptState });
                        if (status) {
                            apptState = translate.instant(status.display);
                        }
                        let name = translate.instant('SMARTTILE_STATE_APPTS', { apptState: apptState, timeperiod: timePeriod });
                        tile.displayNameOverride = `${myLabel}${name}${specificEmployeeLabel}`;
                        break;
                    }
                    case tileNames.topServicesBooked: {
                        // 55: TopServicesBooked
                        let serviceCount = tile.parsedParameters[Meevo.Model.SmartTileParameterNames.numberType].parameterValue;
                        if (serviceCount > 10) serviceCount = 10;
                        if (serviceCount < 1) serviceCount = 1;
                        let name = translate.instant('SMARTTILE_TOP_APPTS_BOOKED', { serviceCount: serviceCount, timeperiod: timePeriod });
                        tile.displayNameOverride = `${myLabel}${name}${specificEmployeeLabel}`;
                        break;
                    }
                    case tileNames.topServicesPerformed: {
                        // 38: TopServicesPerformed
                        let serviceCount = tile.parsedParameters[Meevo.Model.SmartTileParameterNames.numberType].parameterValue;
                        if (serviceCount > 10) serviceCount = 10;
                        if (serviceCount < 1) serviceCount = 1;
                        let name = translate.instant('SMARTTILE_TOP_APPTS_PERFORMED', { serviceCount: serviceCount, timeperiod: timePeriod });
                        tile.displayNameOverride = `${myLabel}${name}${specificEmployeeLabel}`;
                        break;
                    }
                    case tileNames.todaysWaitList: {
                        // 39: TodaysWaitList
                        let name = translate.instant('SMARTTILE_WAIT_LIST', { timeperiod: timePeriod });
                        tile.displayNameOverride = `${myLabel}${name}${specificEmployeeLabel}`;
                        break;
                    }
                    case tileNames.ratingTile: {
                        // 42: RatingTile
                        let name = translate.instant('SMARTTILE_RATINGS', { timeperiod: timePeriod });
                        tile.displayNameOverride = `${myLabel}${name}${specificEmployeeLabel}`;
                        break;
                    }
                    case tileNames.monthlyRecurringRevenue: {
                        // 43: MRR
                        let name = translate.instant('SMARTTILE_MRR', { timeperiod: timePeriod });
                        tile.displayNameOverride = `${myLabel}${name}${specificEmployeeLabel}`;
                        break;
                    }
                    case tileNames.membershipConversion: {
                        // 44: // Membership Conversion
                        let name = translate.instant('SMARTTILE_MEMBERSHIP_CONVERSION', { timeperiod: timePeriod });
                        tile.displayNameOverride = `${myLabel}${name}${specificEmployeeLabel}`;
                        break;
                    }
                    case tileNames.сhurnMonthlyRecurringRevenue: {
                        // 45: Churn MRR
                        let name = translate.instant('SMARTTILE_CHURN_MRR', { timeperiod: timePeriod });
                        tile.displayNameOverride = `${myLabel}${name}${specificEmployeeLabel}`;
                        break;
                    }
                    case tileNames.expansionMonthlyRecurringRevenue: {
                        // 46: Expansion MRR
                        let name = translate.instant('SMARTTILE_EXPANSION_MRR', { timeperiod: timePeriod });
                        tile.displayNameOverride = `${myLabel}${name}${specificEmployeeLabel}`;
                        break;
                    }
                    case tileNames.growthMonthlyRecurringRevenue: {
                        // 47: Growth MRR
                        let name = translate.instant('SMARTTILE_GROWTH_MRR', { timeperiod: timePeriod });
                        tile.displayNameOverride = `${myLabel}${name}${specificEmployeeLabel}`;
                        break;
                    }
                    case tileNames.clientBirthdayOrAnniversary: {
                        // 50: Client Birthday/Anniversary
                        let name = translate.instant('SMARTTILE_CLIENT_BIRTHDAY_ANNIVERSARY', { timeperiod: timePeriod });
                        tile.displayNameOverride = `${myLabel}${name}${specificEmployeeLabel}`;
                        break;
                    }
                    case tileNames.countOfCurrentMemberships: {
                        // 51: CountOfCurrentMemberships
                        let membershipType = tile.parsedParameters[Meevo.Model.SmartTileParameterNames.membershipType].parameterValue;
                        let name = translate.instant('SMARTTILE_COUNT_OF_MEMBERSHIPS', { membershipType: membershipType });
                        tile.displayNameOverride = `${myLabel}${name}${specificEmployeeLabel}`;
                        break;
                    }
                    case tileNames.employeeBirthdayAnniversary: {
                        // 50: Client Birthday/Anniversary
                        var name = translate.instant('SMARTTILE_EMPLOYEE_BIRTHDAY_ANNIVERSARY', { timeperiod: timePeriod });
                        tile.displayNameOverride = `${myLabel}${name}${specificEmployeeLabel}`;
                        break;
                    }
                    case tileNames.serviceCategorySales: {
                        // 53: ServiceCategorySales
                        let parameter = tile.parsedParameters[Meevo.Model.SmartTileParameterNames.serviceCategory];
                        let serviceCategory = parameter.parameterDisplayName || '';
                        if (!parameter.parameterValue) {
                            serviceCategory = myLabel ? '' : translate.instant('LABEL_ALL');
                        }
                        let name = translate.instant('SMARTTILE_SERVICE_CATEGORY_SALES', { serviceCategory: serviceCategory, timeperiod: timePeriod });
                        tile.displayNameOverride = `${myLabel}${name}${specificEmployeeLabel}`;
                        break;
                    }
                    case tileNames.productCategorySales: {
                        // 56: ProductCategorySales
                        let parameter = tile.parsedParameters[Meevo.Model.SmartTileParameterNames.productCategory];
                        let productCategory = parameter.parameterDisplayName || '';
                        if (!parameter.parameterValue) {
                            productCategory = myLabel ? '' : translate.instant('LABEL_ALL');
                        }
                        let name = translate.instant('SMARTTILE_PRODUCT_CATEGORY_SALES', { productCategory: productCategory, timeperiod: timePeriod });
                        tile.displayNameOverride = `${myLabel}${name}${specificEmployeeLabel}`;
                        break;
                    }
                    case tileNames.serviceProviderRequests: {
                        let name = translate.instant('SMARTTILE_SERVICE_PROVIDER_REQUESTS', { timeperiod: timePeriod });
                        tile.displayNameOverride = `${myLabel}${name}${specificEmployeeLabel}`;
                        break;
                    }
                    case tileNames.averageSales: {
                        // 57: AverageSales
                        let ticketCountType = tile.parsedParameters[Meevo.Model.SmartTileParameterNames.ticketCountType].parameterDisplayName || translate.instant('LABEL_SERVICE');
                        let name = translate.instant('SMARTTILE_AVERAGE_SALES', { ticketCountType: ticketCountType, timeperiod: timePeriod });
                        tile.displayNameOverride = `${myLabel}${name}${specificEmployeeLabel}`;
                        break;
                    }
                    case tileNames.membershipsSold: {
                        // 29: MembershipsSold
                        const name = translate.instant('SMARTTILE_MEMBERSHIPS_SOLD', { timeperiod: timePeriod });
                        tile.displayNameOverride = `${myLabel}${name}${specificEmployeeLabel}`;
                        break;
                    }
                    case tileNames.retailUnitsSales: {
                        // 40: RetailUnitsSales
                        const name = translate.instant('SMARTTILE_RETAIL_UNITS_SALES', { timeperiod: timePeriod });
                        const selections = this.updateMultiSelection(translate, tile)
                        const onSelections = !!selections ? ` on ${selections}` : '';
                        tile.displayNameOverride = `${myLabel}${name}${specificEmployeeLabel}${onSelections}`;
                        break;
                    }

                    default: {
                        if (Model.Guard.isNothing(tile.displayNameOverride)) {
                            tile.displayNameOverride = tile.displayName;
                        }
                        break;
                    }
                }
            }
        }

        public static getIncludedDateRanges(tile: Model.SmartCenterSmartTile): number[] | null {
            if (!tile) {
                return null;
            }

            switch (tile.id) {
                case Meevo.Model.SmartTileIds.ServiceCategorySales:
                case Meevo.Model.SmartTileIds.ProductCategorySales:
                case Meevo.Model.SmartTileIds.AverageSales:
                    return [
                        Meevo.Model.TimePeriodEnum.Today,
                        Meevo.Model.TimePeriodEnum.Yesterday,
                        Meevo.Model.TimePeriodEnum.ThisWeek,
                        Meevo.Model.TimePeriodEnum.LastWeek,
                        Meevo.Model.TimePeriodEnum.ThisMonth,
                        Meevo.Model.TimePeriodEnum.LastMonth,
                        Meevo.Model.TimePeriodEnum.ThisQuarter,
                    ];                    

                case Meevo.Model.SmartTileIds.TopServicesBooked:
                case Meevo.Model.SmartTileIds.TopServicesPerformed:
                    return [
                        Meevo.Model.TimePeriodEnum.Today,
                        Meevo.Model.TimePeriodEnum.Yesterday,
                        Meevo.Model.TimePeriodEnum.Tomorrow,
                        Meevo.Model.TimePeriodEnum.ThisWeek,
                        Meevo.Model.TimePeriodEnum.LastWeek,
                        Meevo.Model.TimePeriodEnum.NextWeek,
                        Meevo.Model.TimePeriodEnum.ThisMonth,
                        Meevo.Model.TimePeriodEnum.LastMonth,
                        Meevo.Model.TimePeriodEnum.NextMonth,
                    ];

                case Meevo.Model.SmartTileIds.NetSales:
                case Meevo.Model.SmartTileIds.RebookedClients:
                    return [
                        Meevo.Model.TimePeriodEnum.Today,
                        Meevo.Model.TimePeriodEnum.Yesterday,
                        Meevo.Model.TimePeriodEnum.ThisWeek,
                        Meevo.Model.TimePeriodEnum.LastWeek,
                        Meevo.Model.TimePeriodEnum.ThisMonth,
                        Meevo.Model.TimePeriodEnum.LastMonth,
                    ];

                case Meevo.Model.SmartTileIds.EstimatedSales:
                case Meevo.Model.SmartTileIds.AppointmentsToReschedule:
                    return [
                        Meevo.Model.TimePeriodEnum.LastMonth,
                        Meevo.Model.TimePeriodEnum.LastWeek,
                        Meevo.Model.TimePeriodEnum.Yesterday,
                        Meevo.Model.TimePeriodEnum.Today,
                        Meevo.Model.TimePeriodEnum.Tomorrow,
                        Meevo.Model.TimePeriodEnum.ThisWeek,
                        Meevo.Model.TimePeriodEnum.NextWeek,
                        Meevo.Model.TimePeriodEnum.ThisMonth,
                        Meevo.Model.TimePeriodEnum.NextMonth
                    ];
            }

            return null;
        }

        public static getExcludedDateRanges(tile: Model.SmartCenterSmartTile): number[] | null {
            if (!tile) {
                return null;
            }

            switch (tile.id) {
                 case Meevo.Model.SmartTileIds.HoursNotSold:
                    return [
                        Meevo.Model.TimePeriodEnum.ThisQuarter,
                        Meevo.Model.TimePeriodEnum.NextQuarter,
                        Meevo.Model.TimePeriodEnum.ThisYear,
                        Meevo.Model.TimePeriodEnum.LastQuarter,
                        Meevo.Model.TimePeriodEnum.LastYear,
                        Meevo.Model.TimePeriodEnum.YearToDate,
                        Meevo.Model.TimePeriodEnum.LastYearToDate
                    ];

                case Meevo.Model.SmartTileIds.ClientsWithAppointments:
                    return [
                        Meevo.Model.TimePeriodEnum.ThisQuarter,
                        Meevo.Model.TimePeriodEnum.NextQuarter,
                        Meevo.Model.TimePeriodEnum.ThisYear,
                        Meevo.Model.TimePeriodEnum.LastMonth,
                        Meevo.Model.TimePeriodEnum.LastQuarter,
                        Meevo.Model.TimePeriodEnum.LastYear,
                        Meevo.Model.TimePeriodEnum.YearToDate,
                        Meevo.Model.TimePeriodEnum.LastYearToDate
                    ];
                case Meevo.Model.SmartTileIds.NewClientsWithAppointments:
                    return [
                        Meevo.Model.TimePeriodEnum.ThisQuarter,
                        Meevo.Model.TimePeriodEnum.NextQuarter,
                        Meevo.Model.TimePeriodEnum.ThisYear,
                        Meevo.Model.TimePeriodEnum.LastQuarter,
                        Meevo.Model.TimePeriodEnum.LastYear,
                        Meevo.Model.TimePeriodEnum.YearToDate,
                        Meevo.Model.TimePeriodEnum.LastYearToDate
                    ];
                case Meevo.Model.SmartTileIds.FiveStarRating:
                    return [
                        Meevo.Model.TimePeriodEnum.ThisQuarter,
                        Meevo.Model.TimePeriodEnum.ThisMonth,
                        Meevo.Model.TimePeriodEnum.ThisYear,
                        Meevo.Model.TimePeriodEnum.NextWeek,
                        Meevo.Model.TimePeriodEnum.Tomorrow,
                        Meevo.Model.TimePeriodEnum.NextMonth,
                        Meevo.Model.TimePeriodEnum.NextQuarter,
                        Meevo.Model.TimePeriodEnum.LastQuarter,
                        Meevo.Model.TimePeriodEnum.LastYear,
                        Meevo.Model.TimePeriodEnum.YearToDate,
                        Meevo.Model.TimePeriodEnum.LastYearToDate
                    ];

                case Meevo.Model.SmartTileIds.MonthlyRecurringRevenue:
                case Meevo.Model.SmartTileIds.MembershipConversion:
                case Meevo.Model.SmartTileIds.ChurnMonthlyRecurringRevenue:
                case Meevo.Model.SmartTileIds.ExpansionMonthlyRecurringRevenue:
                case Meevo.Model.SmartTileIds.GrowthMonthlyRecurringRevenue:
                    return [
                        Meevo.Model.TimePeriodEnum.ThisQuarter,
                        Meevo.Model.TimePeriodEnum.NextQuarter,
                        Meevo.Model.TimePeriodEnum.Tomorrow,
                        Meevo.Model.TimePeriodEnum.ThisYear,
                        Meevo.Model.TimePeriodEnum.NextWeek,
                        Meevo.Model.TimePeriodEnum.NextMonth,
                        Meevo.Model.TimePeriodEnum.LastQuarter,
                        Meevo.Model.TimePeriodEnum.LastYear,
                        Meevo.Model.TimePeriodEnum.YearToDate,
                        Meevo.Model.TimePeriodEnum.LastYearToDate
                    ];

                case Meevo.Model.SmartTileIds.ClientBirthdayAnniversary:
                    return [
                        Meevo.Model.TimePeriodEnum.ThisYear,
                        Meevo.Model.TimePeriodEnum.LastYear,
                        Meevo.Model.TimePeriodEnum.YearToDate,
                        Meevo.Model.TimePeriodEnum.LastYearToDate,
                        Meevo.Model.TimePeriodEnum.LastQuarter

                    ];

                case Meevo.Model.SmartTileIds.EmployeeBirthdayAnniversary:
                    return [
                        Meevo.Model.TimePeriodEnum.LastQuarter,
                        Meevo.Model.TimePeriodEnum.LastYear,
                        Meevo.Model.TimePeriodEnum.LastYearToDate,
                        Meevo.Model.TimePeriodEnum.NextQuarter,
                        Meevo.Model.TimePeriodEnum.ThisQuarter,
                        Meevo.Model.TimePeriodEnum.ThisYear,
                        Meevo.Model.TimePeriodEnum.YearToDate
                    ];

                case Meevo.Model.SmartTileIds.PercentageBooked:
                    return [
                        Meevo.Model.TimePeriodEnum.ThisQuarter,
                        Meevo.Model.TimePeriodEnum.NextQuarter,
                        Meevo.Model.TimePeriodEnum.ThisYear,
                        Meevo.Model.TimePeriodEnum.LastQuarter,
                        Meevo.Model.TimePeriodEnum.LastYear,
                        Meevo.Model.TimePeriodEnum.YearToDate,
                        Meevo.Model.TimePeriodEnum.LastYearToDate
                    ];

                case Meevo.Model.SmartTileIds.ScheduledServices:
                    return [
                        Meevo.Model.TimePeriodEnum.ThisQuarter,
                        Meevo.Model.TimePeriodEnum.NextQuarter,
                        Meevo.Model.TimePeriodEnum.ThisYear,
                        Meevo.Model.TimePeriodEnum.LastQuarter,
                        Meevo.Model.TimePeriodEnum.LastYear,
                        Meevo.Model.TimePeriodEnum.YearToDate,
                        Meevo.Model.TimePeriodEnum.LastYearToDate,
                        Meevo.Model.TimePeriodEnum.NextMonth
                    ];
                case Meevo.Model.SmartTileIds.AppointmentCount:
                    return [
                        Meevo.Model.TimePeriodEnum.ThisQuarter,
                        Meevo.Model.TimePeriodEnum.NextQuarter,
                        Meevo.Model.TimePeriodEnum.ThisYear,
                        Meevo.Model.TimePeriodEnum.LastQuarter,
                        Meevo.Model.TimePeriodEnum.LastYear,
                        Meevo.Model.TimePeriodEnum.YearToDate,
                        Meevo.Model.TimePeriodEnum.LastYearToDate
                    ];
                case Meevo.Model.SmartTileIds.ServiceProviderRequests:
                    return [
                        Meevo.Model.TimePeriodEnum.ThisYear,
                        Meevo.Model.TimePeriodEnum.LastYear,
                        Meevo.Model.TimePeriodEnum.YearToDate,
                        Meevo.Model.TimePeriodEnum.LastYearToDate
                    ];
                case Meevo.Model.SmartTileIds.WaitList:
                    return [
                        Meevo.Model.TimePeriodEnum.ThisYear,
                        Meevo.Model.TimePeriodEnum.LastYear,
                        Meevo.Model.TimePeriodEnum.LastQuarter
                    ];
            }

            return null;
        }
        /*
        Collection of known smart tiles that support preview list data
        38	Top Services Performed - TopServicesPerformed
        55	Top Services Booked - TopServicesBooked
        */
        public static previewTiles = [38, 55];

        public static isPreviewTile(id) {
            return _.contains(this.previewTiles, id);
        }
    }

    angular.module("meevo.components.controls")
        .component("smartCenterDesignerProperties", new SmartCenterDesignerProperties());
}
